import AppConstants from "./constants";
import axios from "axios";

export default class Api {
  static _instance;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new Api();
    return this._instance;
  };

  getData = async (data) => {
    return axios.post(`${AppConstants.API_HOST}`, data);
  };

  addEditDeleteRequest = async (data) => {
    return axios.post(`${AppConstants.API_HOST}`, data);
  };

  getExportContactsData = async (data) => {
    return axios.post(`${AppConstants.API_HOST}`, data);
  };
}
